const letters = new Array(26).fill(65).map((value, index) => {
  const code = value + index;
  const upperCase = String.fromCharCode(code);
  const lowerCase = String.fromCharCode(code + 32);
  return {
    label: upperCase,
    value: lowerCase
  };
});

export default [
  {
    label: '学校拼音首字母',
    component: 'ui-chips',
    key: 'pinyin',
    value: '',
    attrOrProp: {
      type: 'choice',
      options: letters
    }
  },
  {
    label: '学校关键词',
    component: 'ui-textfield',
    key: 'keyword',
    value: '',
    attrOrProp: {
      inputType: 'search'
    }
  }
];
